module.exports = __webpack_public_path__ + "img/undraw_setup_wizard_r6mr@2x.d3c6b60c.png";